<template>
    <v-dialog
        v-model="showDialog"
        width="800"
    >
        <v-card>
            <v-card-title style="background-color: #009688; font-size: 15px; color: white;">
                Copy the link below and paste it into a new tab.
                <v-spacer />
                <v-btn
                    @click="handleCopyContractPathFunc"
                >
                    <v-icon>
                        {{ mdiClipboardOutline }}
                    </v-icon>
                    copy
                </v-btn>
                &nbsp;
                <v-btn
                    color="error"
                    @click="showDialog = false"
                >
                    <v-icon>{{ mdiClose }}</v-icon>close
                </v-btn>
            </v-card-title>
            <v-card-text style=" box-shadow: inset 0 4px 10px rgba(0, 0, 0, 0.2); padding-top: 20px; color: black">
                <pre style="white-space: pre-wrap;">file:///{{ showContractPath.path }}</pre>
            </v-card-text>
        </v-card>
        <v-snackbar
            v-model="snackbar.status"
            :timeout="snackbar.timeout"
        >
            {{ snackbar.text }}
            <template #action="{ attrs }">
                <v-btn
                    color="blue"
                    text
                    v-bind="attrs"
                    style="text-transform: none;"
                    @click="snackbar.status = false"
                >
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </v-dialog>
</template>

<script>
import {
    mdiClipboardOutline,
    mdiClose
} from '@mdi/js'
export default {
    props: ['showContractPath'],
    data: ()=>({
        mdiClipboardOutline,
        mdiClose,
        contractUrl: null,
        snackbar: {
            status: null,
            text: null,
            timeout: 2000
        }
    }),
    computed: {
        showDialog: {
            get() {
                return this.showContractPath.status
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        showContractPath: {
            handler(newVal) {
                if (newVal.status) {
                    this.contractUrl = newVal.path
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        handleCopyContractPathFunc() {
            const contractPath = `file://${this.contractUrl}`

            if (!contractPath) {
                this.snackbar.status = true
                this.snackbar.text = 'No contract path to copy.'
                return
            }

            // Modern approach - Clipboard API
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(contractPath)
                    .then(() => {
                        this.snackbar.status = true
                        this.snackbar.text = 'Contract path copied successfully!'
                    })
                    .catch(() => {
                        // Fall back to the alternative method if the Clipboard API fails
                        this.copyToClipboardFallback(contractPath)
                    })
            } else {
                // Fallback for older browsers or non-secure contexts
                this.copyToClipboardFallback(contractPath)
            }
        },

        // Separate fallback method for better organization
        copyToClipboardFallback(text) {
            try {
                const textArea = document.createElement('textarea')
                textArea.value = text

                // Make the textarea out of viewport
                textArea.style.position = 'fixed'
                textArea.style.left = '-999999px'
                textArea.style.top = '-999999px'
                textArea.style.zIndex = '999999'
                textArea.setAttribute('readonly', '') // Prevent mobile keyboard from appearing

                // For dialogs, we need to append to the dialog or root element
                // Find the dialog if it's open
                const activeDialog = document.querySelector('.v-dialog--active')
                const appendTarget = activeDialog || document.body

                appendTarget.appendChild(textArea)

                // Handle iOS devices specifically
                if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
                    textArea.contentEditable = true
                    textArea.readOnly = false
                    const range = document.createRange()
                    range.selectNodeContents(textArea)
                    const selection = window.getSelection()
                    selection.removeAllRanges()
                    selection.addRange(range)
                    textArea.setSelectionRange(0, 999999)
                } else {
                    textArea.select()
                }

                const successful = document.execCommand('copy')

                if (successful) {
                    this.snackbar.status = true
                    this.snackbar.text = 'Contract path copied successfully!'
                } else {
                    this.snackbar.status = true
                    this.snackbar.text = 'Failed to copy contract path. Please try again.'
                }
            } catch (err) {
                // console.error('Copy fallback error:', err);
                this.snackbar.status = true
                this.snackbar.text = 'Failed to copy contract path. Please try again.'
            } finally {
                // Find and remove the textarea, wherever it was appended
                const textArea = document.querySelector('textarea[style*="position: fixed"][style*="left: -999999px"]')
                if (textArea && textArea.parentNode) {
                    textArea.parentNode.removeChild(textArea)
                }
            }
        }
    }
}
</script>
